import { getEnv } from './getEnv';

// If you want to test analytics locally, return true from this method
// export const analyticsEnabledByEnv = () => true;

export const analyticsEnabledByEnv = () =>
  window.location.href.includes('https://d15wyp49r62mh9.cloudfront.net') ||
  getEnv('NODE_ENV') === 'production';
